import { LanguageService } from '@app/core/services/language.service';
import { IconLoaderService } from '@app/core/services/icon-loader.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { FormlyFieldAnyComponent } from '@app/shared/components/formly-components/formly-field-any/formly-field-any.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { IonicModule } from "@ionic/angular";
import { SubSink } from 'subsink';

interface CheckboxOption {
  code: string;
  label: string;
  value: boolean | null;
}

@Component({
  selector: 'app-formly-field-checkbox',
  templateUrl: './formly-field-checkbox.component.html',
  styleUrls: ['./formly-field-checkbox.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormlyModule,
    FormsModule,
    IonicModule,
],
})
export class FormlyFieldCheckboxComponent extends FormlyFieldAnyComponent  implements OnInit, OnDestroy {
  public value: { [key: string]: boolean } = {};
  private languageService = inject(LanguageService);
  private subsink = new SubSink();

  constructor(private changeDetectorRef: ChangeDetectorRef) {
    super();
  }
  
  ngOnInit(): void {
    // Subscribe to formControl value changes to update localValue
    this.subsink.sink = this.formControl.valueChanges.subscribe(value => {
      this.updateLocalValue(value);
    });
    
    // Initialize with current value
    this.updateLocalValue(this.formControl.value);
  }

  ngOnDestroy(): void {
    this.subsink.unsubscribe();
  }
  
  private updateLocalValue(modelValue: { [key: string]: boolean } | null | undefined): void {
    this.value = modelValue ? modelValue : {};
 }


  public getDisabledClass(): string {
    return (this.options.formState.disabled || this.field.props['disabled']) ? ' disabled' : '';
  }


  onValueChange(code:string, newValue: boolean): void {
    this.value[code] = newValue;
    this.updateFormControl();
  }

  private updateFormControl(): void {
    
    this.formControl.setValue(this.value);
    this.formControl.markAsDirty();
    
    // Trigger onChange callbacks if defined
    this.onChange(this.value);
    this.changeDetectorRef.markForCheck();
  }

  public getSelectedItemsAsText(): string {
    const selectedItems = ((this.field.props['options'] as CheckboxOption[]) || []).filter(option => this.value[option.code]);
    return selectedItems.map(option => this.languageService.instant(option.label)).join(' + ');
  }
}
